export default function($) {
  $(document).ready(function() {

    $('.js-tooltip').tooltipster({
      theme: ['pow__tooltip'],
      interactive: true,
    });

    // uncomment to show so you can inspect in browser
    // $('.js-tooltip').tooltipster('open');
  });
}
